// Module
var code = "<div ui-view class=\"flex layout-column\"></div>\n";
// Exports
module.exports = code;